import { Span } from "../../html";
import { VisuallyHidden } from "../../visually-hidden";
import { jsx as _jsx } from "react/jsx-runtime";
export function NewTabIndicator() {
  return /*#__PURE__*/_jsx(VisuallyHidden, {
    as: Span,
    children: "(opens in a new tab)"
  });
}